<template>
  <div v-if="project != null">
    <h1>Resultado de la visita</h1>
    <table class="table" >
      <thead>
      </thead>
      <tbody>        
        <tr>
          <td width="20%;">
            Concepto sobre las condiciones para el Teletrabajo
          </td>
          <td width="80%;">
            <input type="text" name="visit_result_concept_telework" class="form-control" id="visit_result_concept_telework" placeholder="" v-model="project.visit_result_concept_telework"/>
          </td>
        </tr>
        <tr>
          <td width="20%;">
            Concepto general de la visita
          </td>
          <td width="80%;">
            <input type="text" name="visit_result_concept_visit" class="form-control" id="visit_result_concept_visit" placeholder="" v-model="project.visit_result_concept_visit"/>
          </td>
        </tr>
        <tr>
          <td width="20%;">
            Recomendaciones del profesional
          </td>
          <td width="80%;">
            <input type="text" name="visit_result_valoration_visit" class="form-control" id="visit_result_valoration_visit" placeholder="" v-model="project.visit_result_valoration_visit"/>
          </td>
        </tr>
      </tbody>
    </table>
    <b-button variant="primary" @click.prevent="save">Guardar</b-button>
		<div :class="`alert ${typeMessage}`" role="alert" id="message-update" v-if="message != ''">
			{{message}}
		</div>    
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios';
import { mapGetters, mapMutations } from 'vuex'
import SelectLocal from './../../own/select-local.vue'

export default {
  name: 'VisitResult',
  props: ['project_id', 'assignment_id'],  
  computed: {
    ...mapGetters(['projectId', 'assignmentId', 'project', 'assignment', 'selects'])
  },  
  data() {
    return {
			message: '',
			typeMessage: ''
    }
  },
  components: {
    'select-local': SelectLocal,
  },  
  methods: {
    ...mapMutations(['changeProjectId', 'changeAssignmentId', 'changeProject', 'changeAssignment', 'changeSelects']),
    defaultAxios(){
			var token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
			axios.defaults.headers['x-csrf-token'] = token
			axios.defaults.headers.common['Accept'] = 'application/json';
			axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    },
    getInformationWork() {
      console.log("3***")
			axios.get(`/information_work.json?project_id=${this.project_id}&assignment_id=${this.assignment_id}`).then(res=>{
				if(res.status == 200){
          this.changeProjectId(this.project_id)
          this.changeAssignmentId(this.assignment_id)
          this.changeProject(res.data.project)
          this.changeAssignment(res.data.assignment)
          this.changeSelects(res.data.selects)
				}
			})
    },
    save(){
      this.defaultAxios()
      let project = this.project
      delete project.family_compositions
      delete project.family_references
      delete project.family_sicks
      delete project.family_interviews
      delete project.working_condition            
			axios.put(`/update_information_personal`, { project: project }).then(res=>{
				if(res.status == 200){
          this.getInformationWork()
          this.showMessage('Proceso actualizado', 'alert-success')
				}else{
          this.showMessage('El registro no se pudo actualizar', 'alert-danger')
        }
			}, (err) => {
        this.showMessage('El registro no se pudo actualizar', 'alert-danger')
      })
    },
		showMessage(message, typeMessage){
			this.message = message
			this.typeMessage = typeMessage
			setTimeout(() => this.message = '', 3000)
		},        
  },
  created () {

  },
  watch: {
    data(newValue, oldValue) {
      
    }
  },
  filters: {
    fnName: function(value) {
      return value;
    }
  }
}
</script>

<style scoped>

</style>